<template>
  <div class="home" :class="globalTheme">
    <hz-header/>
    <div class="home-main">
        <hz-aside/>
        <div class="staticBox" :style="{'margin-left':(navStable ? '170px': '10px')}">
            <transition name="el-zoom-in-center">
                <keep-alive :include="keepAlive">
                    <router-view v-if="isfresh"></router-view>
                </keep-alive>
            </transition>
        </div>
    </div>
    <guidemask/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import across from "@/config/components/across.js"
import hzHeader from '@/components/structure/Header.vue'
import hzAside from '@/components/structure/Aside.vue'
import Guidemask from '@/components/structure/Guidemask'
import { set_local_cache, get_local_cache, set_session_cache, get_session_cache} from "@/config/cache/cache.js"
import {$http} from '@/config/api/axios'
export default {
    name:'Home',
    provide(){
        return{
            reload:this.reload
        }
    },
    components:{
        hzHeader,
        hzAside,
        Guidemask
    },
    computed:{
        ...mapGetters('Home', [
            'keepAlive',
            'navStable',
            'freshName',
            'globalTheme'
        ])
    },
    data(){
        return{
            isfresh:true,
        }
    },
    methods:{
        reload(){
            this.isfresh = false;
            this.$nextTick(()=>{
                this.isfresh = true
                this.keepAlive.push(this.freshName)
            })
        },
    },
    mounted(){
    },
    created(){
        const lang = get_local_cache('language-type');
        if(lang === 'zh-CN'){
            this.$i18n.locale = "zh";
            this.$root.$lang = 'zh-CN';
        }else if(lang === 'en-US'){
            this.$i18n.locale = "en";
            this.$root.$lang = 'en-US';
        }
        if(!get_local_cache('echartsTheme')){
            localStorage.setItem('echartsTheme', 'theme1');
        }
        const sessionToken = get_session_cache("Access-Token");
        const userData = JSON.parse(get_local_cache('tokenUser'))
        this.$root.$permissionMap = new Map() // 放到这里为了防止报错
        if(!!sessionToken && !!userData){
            set_session_cache('loginId',userData.tokenUserId)
            set_session_cache('loginType',userData.tokenUserType) // 用户类型userType===1008002时为运维账户
            set_session_cache('loginName',userData.tokenUserName)
            $http("get", "permission/listSelfPermissions", {}).then((res) => {
                if(res.status == 'SUCCESS'){
                    set_local_cache("permissions",res.data);
                    res.data.forEach(item => {
                        this.$root.$permissionMap.set(item,true)
                    });
                }else{
                    this.$message.error(lang === 'zh-CN'?res.message:res.enMessage);
                }
            });
            // 显示引导页的逻辑 ↓
            let loginCollection = get_local_cache('loginCollection') || [];
            if(loginCollection.length != 0){
                loginCollection = JSON.parse(loginCollection)
            }
            if(loginCollection.includes(userData.tokenUserId)){ // 登录过的ID集合里没有才会push一个并且显示引导页
                this.$store.commit('Home/SET_GUIDE_SHOW',false);
            }else{
                loginCollection.push(userData.tokenUserId)
                set_local_cache('loginCollection',loginCollection)
                this.$store.commit('Home/SET_GUIDE_SHOW',true);
            }
        }else{
            this.$router.push('/login')
        }
    }
}
</script>
<style lang="less">
.home{
    min-width: 1530px;
    overflow: hidden;
    height: 100%;
    padding-bottom: 10px;
    .home-main{
        display: flex;
        height: calc(100% - 55px);
        .staticBox{
            margin-top: 38px;
            width: calc(100% - 50px);
            transition: all .4s;
        }
    }
}
</style>